import {Resource} from "@k/global/resourcemanager/resource";

export class KeyValueResourceContainer {
    private store = [] as {key:string,value:Resource}[];

    public add(resource:Resource) {
        this.store.push({key:resource.resourceName, value:resource})
    }

    public get(key) {
        const keyvalue = this.store.find(e=>e.key === key) || null;
        return keyvalue === null ? null : keyvalue.value;
    }
    public exists(key) {
        return this.get(key) !== null;
    }
    public filterResources(func):{key,value}[] {
        return this.store.filter(e=>func(e.value));
    }
    public delete(resourcename):void {
        this.store = this.store.filter(e => e.key !== resourcename);
    }

}
